import React from 'react';

const WithCondition = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children;

export default WithCondition;
